import PropTypes from 'prop-types';
import React from 'react';
import { withLocalize } from 'react-localize-redux';
import { BadgeVariants } from '../../components/atoms/Badge';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import Tooltip from '../../components/molecules/Tooltip';
import { SECTION_ACCESS_TYPES } from '../../utils/consts';
import { CUSTOM_ACCESS_TYPE, translationPrefix as translationRootPrefix } from '../utils';

const translationPrefix = `${translationRootPrefix}.MANAGE_PERMISSIONS_PAGE`;

const ICON_NAMES_BY_ACCESS_TYPE = {
    [SECTION_ACCESS_TYPES.VIEW]: 'eye',
    [SECTION_ACCESS_TYPES.EDIT]: 'check',
    [CUSTOM_ACCESS_TYPE]: 'adjustments-horizontal',
};

const ICON_VARIANTS_BY_ACCESS_TYPE = {
    [SECTION_ACCESS_TYPES.VIEW]: IconVariants.ACTIVE,
    [SECTION_ACCESS_TYPES.EDIT]: IconVariants.SUCCESS,
    [CUSTOM_ACCESS_TYPE]: IconVariants.WARNING,
};

export const BADGE_COLORS_BY_ACCESS_TYPE = {
    [SECTION_ACCESS_TYPES.VIEW]: BadgeVariants.ACTIVE,
    [SECTION_ACCESS_TYPES.EDIT]: BadgeVariants.SUCCESS,
    [CUSTOM_ACCESS_TYPE]: BadgeVariants.WARNING,
};

const AccessTypeIcon = ({
    accessType,
    size = IconSizes.SMALL,
    wrapperClass = '',
    withTooltip = true,
    ...iconProps
}) => (
    <Tooltip
        titleTranslationKey={`${translationPrefix}.SECTION_ACCESS_TYPES_TAB.${accessType}`}
        wrapperClass={wrapperClass}
        disabled={!withTooltip}
    >
        <Icon
            name={ICON_NAMES_BY_ACCESS_TYPE[accessType]}
            size={size}
            variant={ICON_VARIANTS_BY_ACCESS_TYPE[accessType]}
            {...iconProps}
        />
    </Tooltip>
);

AccessTypeIcon.propTypes = {
    accessType: PropTypes.string.isRequired,
    size: PropTypes.oneOf(Object.values(IconSizes)),
    wrapperClass: PropTypes.string,
    withTooltip: PropTypes.bool,
};

export default withLocalize(AccessTypeIcon);
